<template>
  <div class="orderdetail">
    <cube-page type="orderdetail-view" title="预定详情">
      <div slot="content" v-if="reservation">
        <div class="box-main">
          <div class="box">
            <h3>预定信息</h3>
            <div class="list">
              <div class="list-item max">
                <span>团队名称：</span>
                <span>{{ reservation.team_name || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>出团：</span>
                <span>{{ reservation.start_time || '-' }}</span>
              </div>
              <div class="list-item">
                <span>完团：</span>
                <span>{{ reservation.end_time || '-' }}</span>
              </div>
              <div class="list-item">
                <span>天数：</span>
                <span>{{ reservation.play_days || '-' }}</span>
              </div>
              <div class="list-item">
                <span>人数：</span>
                <span>{{ reservation.team_number || '-' }}</span>
              </div>
              <div class="list-item">
                <span>类型：</span>
                <span>{{ reservation.team_type_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>职级：</span>
                <span>{{ reservation.guide_rank_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>性别：</span>
                <span>{{ reservation.gender_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>年龄：</span>
                <span>{{ reservation.age_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>语种：</span>
                <span>{{ reservation.lang_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>擅长：</span>
                <span>{{ reservation.skill_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>价格：</span>
                <span>{{ reservation.total_price || '-' }}</span>
              </div>
              <div class="list-item">
                <span>状态：</span>
                <span style="color: red">{{ reservation.status_text || '暂无' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box-main" v-if="reservation.guider != null">
          <div class="box">
            <h3>导游信息</h3>
            <div class="list">
              <div class="list-item">
                <span>昵称：</span>
                <span>{{ reservation.guider.nickname || '-' }}</span>
              </div>
              <div class="list-item">
                <span>电话：</span>
                <span>{{ reservation.guider.phone || '-' }}</span>
              </div>
              <div class="list-item">
                <span>职级：</span>
                <span>{{ reservation.guider.rank_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>性别：</span>
                <span>{{ reservation.guider.gender_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>年龄：</span>
                <span>{{ reservation.guider.age || '-' }}</span>
              </div>
              <div class="list-item">
                <span>语种：</span>
                <span>{{ reservation.guider.lang_text || '-' }}</span>
              </div>
              <div class="list-item">
                <span>擅长：</span>
                <span>{{ reservation.guider.skill_text || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-btn" v-if="reservation.status == '12'">
          <van-button type="info" :loading="loading" @click="handleStatus('ok')">确认</van-button>
          <van-button type="warning" @click="handleStatus('no')">拒绝</van-button>
        </div>
        <van-overlay :show="showMemo" @click="showMemo = false">
          <div class="wrapper" @click.stop>
            <div class="block">
              <h4>备注</h4>
              <van-field v-model="message" rows="2" :autosize="autosize" label="填写拒绝理由" type="textarea" maxlength="100"
                placeholder="请输入拒绝理由" show-word-limit clearable />
              <div class="btn">
                <van-button type="default" size="small" @click="showMemo = false">取消</van-button>
                <van-button type="primary" size="small" plain @click="confirmbtnShowMemo">关闭</van-button>
                <van-button type="primary" size="small" @click="confirmbtn">重新发布</van-button>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </cube-page>
  </div>
</template>

<script>
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import {
  Toast,
} from 'vant';

export default {
  components: {
    CubePage,
  },
  data() {
    return {
      reservation: null,
      showMemo: false,
      message: '',
      onlyId: '',
      autosize: {
        minHeight: 100
      },
      loading: false
    };
  },
  mounted() {
    this.onlyId = this.$route.query.id;
    this.getData(this.onlyId)
  },
  methods: {
    getData(id) {
      let that = this;
      var url = "/addons/litestore/api.distributor/reserveSave"
      //这里直接调用网络接口
      util.get(url, { id }, (result) => {
        if (result.data != null) {
          that.reservation = result.data;
        }
      });
    },
    handleStatus(type) {
      if (type == 'no') {
        this.showMemo = true;
      } else {
        this.loading = true;
        this.gotoSubmit(13);
      }
    },
    // 提交备注
    confirmbtn() {
      let message = this.message;
      if (!message) {
        return Toast('拒绝理由不能为空')
      }
      this.showMemo = false;
      this.gotoSubmit(20)
    },
    confirmbtnShowMemo() {
      this.showMemo = false;
      this.gotoSubmit(99)
    },
    gotoSubmit(type) {
      let params = {
        id: this.reservation.id,
        status: type,
        emo: this.message
      }
      let url = '/addons/litestore/api.distributor/reserveConfirm';
      util.post(url, params, (res) => {
        if (res.code == 1) {
          Toast(res.msg);
          this.showMemo = false;
          this.message = '';
          setTimeout(() => {
            this.getData(this.onlyId)
          }, 1000)
        }
      })
      setTimeout(() => {
        this.loading = false;
      }, 2000)
    },
  },
}
</script>
<style lang="less" scoped="scoped">
.box-main {
  padding: 20px;

  .box {
    padding: 10px 0;
    background: #fff;
    border-radius: 8px;

    h3 {
      border-bottom: 1px solid #eee;
      padding: 0 15px 10px;
    }

    .list {
      padding: 15px 15px 0;
      display: flex;
      flex-flow: wrap;
      font-size: 14px;

      .list-item {
        width: 50%;
        margin-bottom: 10px;

        span:first-child {
          color: #666;
        }
      }

      .max {
        width: 100%;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}

.footer-btn {
  position: fixed;
  left: 5%;
  bottom: 40px;
  width: 90%;
  display: flex;
  justify-content: space-between;

  .van-button {
    width: 45%;
    border-radius: 8px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .block {
    width: 80%;
    min-height: 200px;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;

    h4 {
      text-align: center;
      margin-bottom: 20px;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 15px;

      button {
        margin-left: 15px;
        padding: 0 20px;
        border-radius: 4px;
      }
    }
  }
}
</style>
